module.exports = __webpack_public_path__ + "img/banner3.229d929b.jpg";